import React, { useEffect, useState } from 'react'
import { Col, Row, Steps } from 'antd'
import { buildStepName } from '../../../shared/tournamentSteps'
import TournamentCheckin from './checkin/TournamentCheckin'
import TournamentPools from './pool/TournamentPools'
import TournamentPoolScoring from './pool/TournamentPoolScoring'
import TournamentTableScoring from './table/TournamentTableScoring'
import TournamentFinal from './final/TournamentFinal'
import TournamentBestofScoring from './bestof/TournamentBestofScoring'

const { Step } = Steps

const TournamentProcess = (props) => {
  const [processSteps, setProcessSteps] = useState([])

  const setupConfig = (type, index) => {
    return {
      duration: props.tournament[`${type}_duration_${index}`],
      name: props.tournament[`${type}_name_${index}`],
      promotion: props.tournament[`${type}_promotion_${index}`],
      promotion_exact: props.tournament[`${type}_promotion_exact_${index}`],
      score: props.tournament[`${type}_score_${index}`],
      tournament_name: props.tournament.title,
      tournament_id: props.tournament.uuid
    }
  }

  useEffect(() => {
    const steps = []

    for (let i = 0; i < props?.tournament?.schedule?.length; i += 1) {
      const scheduleItem = props.tournament.schedule[i]

      switch (scheduleItem) {
        case 'pools': {
          steps.push({
            id: 'pools_arrangement',
            index: i,
            title: buildStepName(props.tournament, 'pools_arrangement', i)
          })
          steps.push({
            id: scheduleItem,
            canGoLive: true,
            index: i,
            title: buildStepName(props.tournament, scheduleItem, i),
            config: setupConfig('pool', i)
          })
          break
        }
        case 'table': {
          steps.push({
            id: scheduleItem,
            canGoLive: true,
            index: i,
            title: buildStepName(props.tournament, scheduleItem, i),
            config: setupConfig('table', i)
          })
          break
        }
        default: {
          steps.push({
            id: scheduleItem,
            index: i,
            title: buildStepName(props.tournament, scheduleItem, i)
          })
        }
      }
    }

    setProcessSteps(steps)
    // eslint-disable-next-line
  }, [props.tournament])

  const handleOnStepStart = () => {
    props.onStepStart()
  }

  const handleOnStepFinished = () => {
    props.onStepFinish()
  }

  useEffect(() => {
    if (processSteps?.[props?.currentStep]?.canGoLive) {
      props.canGoLive(true)
    } else {
      props.canGoLive(false)
    }
  }, [props.currentStep, processSteps])

  return (
    <div>
      <Row>
        <Col span={24} style={{ marginBottom: '1em' }}>
          <Steps current={props.currentStep}>
            {processSteps.map((item, index) => (
              <Step key={index} title={item.title} />
            ))}
          </Steps>

        </Col>
      </Row>

      {processSteps.map((item, index) => {
        if (index === props.currentStep) {
          switch (item.id) {
            case 'checkin': {
              return (
                <TournamentCheckin key={`${item.id}-${index}`} tournament={props.tournament} step={processSteps[props.currentStep].index} hidden={index !== props.currentStep} onTournamentUpdate={props.onTournamentUpdate} onUpdate={props.onUpdate} />
              )
            }
            case 'pools_arrangement' : {
              return (
                <TournamentPools key={`${item.id}-${index}`} tournament={props.tournament} step={processSteps[props.currentStep].index} hidden={index !== props.currentStep} onTournamentUpdate={props.onTournamentUpdate} />
              )
            }
            case 'pools' : {
              return (
                <TournamentPoolScoring key={`${item.id}-${index}`} tournament={props.tournament} step={processSteps[props.currentStep].index} hidden={index !== props.currentStep} onStart={handleOnStepStart} onFinish={handleOnStepFinished} onTournamentUpdate={props.onTournamentUpdate} />
              )
            }
            case 'table' : {
              return (
                <TournamentTableScoring key={`${item.id}-${index}`} tournament={props.tournament} step={processSteps[props.currentStep].index} onStart={handleOnStepStart} onFinish={handleOnStepFinished} onTournamentUpdate={props.onTournamentUpdate} />
              )
            }
            case 'bestof': {
              return (
                <TournamentBestofScoring key={`${item.id}-${index}`} tournament={props.tournament} step={processSteps[props.currentStep].index} onStart={handleOnStepStart} onFinish={handleOnStepFinished} onTournamentUpdate={props.onTournamentUpdate} />
              )
            }
            case 'final': {
              return (
                <TournamentFinal key={`${item.id}-${index}`} tournament={props.tournament} step={processSteps[props.currentStep].index} onTournamentUpdate={props.onTournamentUpdate} />
              )
            }
            default: {
              return (<></>)
            }
          }
        }
        return (<div key={`step_${index}`} />)
      })}
    </div>
  )
}

export default TournamentProcess
